<template>
	<div class="body">
		<el-container>
			
			<el-header>
				<HeaderCus></HeaderCus>
			</el-header>
			
			<el-main>
				<div class="content_main">
					<div class="mbxdh">
						<el-breadcrumb separator-class="el-icon-arrow-right">
						  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
						  
						  <el-breadcrumb-item :to="{ path: '/list_biaogan'}">标杆企业</el-breadcrumb-item>
						  
						  <!-- <el-breadcrumb-item v-if="daqu == 1">大区A</el-breadcrumb-item>
						  <el-breadcrumb-item v-if="daqu == 2">大区B</el-breadcrumb-item> -->
						  <!-- <el-breadcrumb-item v-if="tuwen_type == 43">知识产权工具</el-breadcrumb-item>
						  <el-breadcrumb-item v-if="tuwen_type == 45">知识产权案例</el-breadcrumb-item> -->
						  
						</el-breadcrumb>
					</div>
					
					<div class="nrqy">
						
						<el-row class="tiaojian_elrow" style="margin-top: -10px;">
							<el-col :span="2">
								<div class="tiaojian_line_row_left">
									按地区：
								</div>
							</el-col>
							<el-col :span="21">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_prov_type[0]" @click="clickDiqu(0, 0)">不限</el-tag>
									<el-dropdown size="small" placement="top-end" @command="selectProv">
										<span class="el-dropdown-link">
											{{prov_text}}<i class="el-icon-arrow-down el-icon--right"></i>
										</span>
										<el-dropdown-menu slot="dropdown">
											<el-dropdown-item command="0">不限省份</el-dropdown-item>
											<el-dropdown-item v-for="(item, index) in list_prov" :key="index" :command="item.id">
												{{item.name}}
											</el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown>
									<el-dropdown size="small" placement="top-end" @command="selectCity">
										<span class="el-dropdown-link">
											{{city_text}}<i class="el-icon-arrow-down el-icon--right"></i>
										</span>
										<el-dropdown-menu slot="dropdown">
											<el-dropdown-item command="0">不限地市</el-dropdown-item>
											<el-dropdown-item v-for="(item, index) in list_city" :key="index" :command="item.id">
												{{item.name}}
											</el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown>
								</div>
							</el-col>
						</el-row>
						
						
						<el-row class="tiaojian_elrow">
							<el-col :span="2">
								<div class="tiaojian_line_row_left">
									按领域：
								</div>
							</el-col>
							<el-col :span="21">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_lingyu_type[0]" @click="clickLingyu(0, 0)">不限</el-tag>
									<el-tag size="small" v-for="(item, index) in list_lingyu" :key="index" :type="list_lingyu_type[index+1]" @click="clickLingyu(index+1, item.dictValue)">{{item.dictLabel}}</el-tag>
								</div>
							</el-col>
						</el-row>
						
						<el-row class="tiaojian_elrow">
							<el-col :span="2">
								<div class="tiaojian_line_row_left">
									按年份：
								</div>
							</el-col>
							<el-col :span="21">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_year_type[0]" @click="clickYear(0, 0)">不限</el-tag>
									<el-tag size="small" v-for="(item, index) in list_year" :key="index" :type="list_year_type[index+1]" @click="clickYear(index+1, item.dictValue)">{{item.dictLabel}}</el-tag>
								</div>
							</el-col>
						</el-row>
						<el-row class="tiaojian_elrow" v-show="is_show_month">
							<el-col :span="2" :push="1">
								<div class="tiaojian_line_row_left" style="font-size: 13px;">
									按月份：
								</div>
							</el-col>
							<el-col :span="20" :push="1">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_month_type[0]" @click="clickMonth(0, 0)">不限</el-tag>
									<el-tag size="small" v-for="(item, index) in list_month" :key="index" :type="list_month_type[index+1]" @click="clickMonth(index+1, item.dictValue)">{{item.dictLabel}}</el-tag>
								</div>
							</el-col>
						</el-row>
						
						<el-row class="tiaojian_elrow">
							<el-col :span="2">
								<div class="tiaojian_line_row_left">
									按模块：
								</div>
							</el-col>
							<el-col :span="21">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_daqu_type[0]" @click="clickDaqu(0, 0)">不限</el-tag>
									<el-tag type="info" size="small" v-for="(item, index) in list_daqu" :key="index" :type="list_daqu_type[index+1]" @click="clickDaqu(index+1, item.id)">{{item.name}}</el-tag>
								</div>
							</el-col>
						</el-row>
						<el-row class="tiaojian_elrow" v-show="is_show_mokuai">
							<el-col :span="2" :push="1">
								<div class="tiaojian_line_row_left" style="font-size: 13px;">
									二级模块：
								</div>
							</el-col>
							<el-col :span="20" :push="1">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_mokuai_type[0]" @click="clickMokuai(0, 0)">不限</el-tag>
									<el-tag size="small" v-for="(item, index) in list_mokuai" :key="index" :type="list_mokuai_type[index+1]" @click="clickMokuai(index+1, item.id)">{{item.name}}</el-tag>
								</div>
							</el-col>
						</el-row>
						
						<!-- <el-row class="tiaojian_elrow">
							<el-col :span="2">
								<div class="tiaojian_line_row_left">
									按其它：
								</div>
							</el-col>
							<el-col :span="21">
								<div class="tiaojian_line_row_right">
									<el-tag size="small">其它123</el-tag>
									<el-tag size="small">其它456</el-tag>
								</div>
							</el-col>
						</el-row> -->
						
						<el-row class="tiaojian_elrow" style="border: 0px;">
							<el-col :span="21" :push="1">
								<div class="tiaojian_line_row_right">
									<el-input
										placeholder="请输入关键词搜索..."
										prefix-icon="el-icon-search"
										style="width: 40%;"
										v-model="keyword"
										:clearable="true"
										@clear="clearInput"
										>
									</el-input>
									
									<el-dropdown @command="selectSearchType">
									  <el-button plain size="medium">
									    {{search_type}}<i class="el-icon-arrow-down el-icon--right"></i>
									  </el-button>
									  <el-dropdown-menu slot="dropdown">
									    <el-dropdown-item v-for="(item, index) in list_search_type" :key="index" :command="item.val">{{item.text}}</el-dropdown-item>
									  </el-dropdown-menu>
									</el-dropdown>
									
									<el-button type="primary" size="medium" @click="doSearch" v-loading.fullscreen.lock="fullscreenLoading">搜索</el-button>
									<span class="span_search_result">检索到{{total}}条数据</span>
								</div>
							</el-col>
						</el-row>
						
					</div>
					
					<div class="neirong_line">
						<div class="neirong_line_left">
							
							<el-empty description="没找到你想要的数据..." v-show="is_show_empty"></el-empty>
							
							<div class="neirong_line_region" v-for="(item, index) in list_record">
								<div class="neirong_line_title" @click="toDetail(item.id, item.daquId, item.mokuaiId)">
									<div class="neirong_line_title_icon"></div>
									{{item.name}}
									<span v-show="item.daquName != null">【{{item.daquName}}】</span>
									<span v-show="item.mokuaiName != null">[{{item.mokuaiName}}]</span>
								</div>
								<!-- <div class="neirong_line_summary">
									{{item.summary}}
								</div> -->
								<div class="neirong_line_option">
									<el-row>
										<el-col :span="4">
											&nbsp;
											<!-- <el-button icon="el-icon-star-off" size="mini"> 加入收藏 </el-button> -->
										</el-col>
										<el-col :span="4" :offset="12">
											<el-button icon="el-icon-document" size="mini" style="float: right;" @click="toDetailSigle(item.id, 'wd_detail')"> 问询与答复 </el-button>
										</el-col>
										<el-col :span="4">
											<el-button icon="el-icon-data-analysis" size="mini" style="float: right;" @click="toDetailSigle(item.id, 'bg_detail')"> 企业详情 </el-button>
										</el-col>
									</el-row>
								</div>
								<div class="neirong_line_split"></div>
							</div>
							
							
							<div class="neirong_line_page">
								<el-pagination
								  background
								  layout="prev, pager, next, jumper"
								  :page-size="9"
								  :total="total"
								  @current-change="handlePage"
								  >
								</el-pagination>
							</div>
							
						</div>
						
						
						<div class="neirong_line_right" style="margin-bottom: 15px;" v-show="cur_user">
							<div class="neirong_right_header">
								<div class="myxxx_right_title">我的<label>【{{ kw }}】</label></div>
							</div>
							<div class="myxxx_right_body" style="height: 380px;">
								<el-row>
									<!-- <el-input
									type="textarea"
									:autosize="{ minRows: 9, maxRows: 9}"
									:placeholder="'在此可以保存和备忘您企业的相关模块信息，用于跟标杆企业对标。\n\n输入信息点击保存试试吧……'"
									v-model="content">
									</el-input> -->
									<div style="border: 1px solid #ccc;">
										<!-- <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor"
											:defaultConfig="toolbarConfig" :mode="mode" /> -->
										<Editor style="height: 340px; overflow-y: hidden;" v-model="content"
											:defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" @customPaste="customPaste" />
									</div>
								</el-row>
								<el-row style="display: flex; justify-content: center; margin-top: 5px">
									<el-button v-if="is_show_myxxx_savebtn == 1" type="primary" style="width: 210px; background-color: #E75122; border-color: #E75122;" @click="updateUserMyxxxContent">保存<label>【{{ kw }}】</label></el-button>
									<el-button v-if="is_show_myxxx_savebtn == 0" type="info" style="width: 210px;" :disabled="true" >暂无保存权限</el-button>
								</el-row>
							</div>
						</div>

						<div class="neirong_line_right">
							<AdverRightCus></AdverRightCus>
						</div>
					</div>
					
				</div>
			</el-main>
			
			<el-footer>
				<FooterCus></FooterCus>
			</el-footer>
			
		</el-container>
	</div>
</template>

<script>
	import HeaderCus from '../components/header.vue'
	import FooterCus from '../components/footer.vue'
	import AdverRightCus from '../components/adverRight.vue'
	import {
		Editor,
		Toolbar
	} from '@wangeditor/editor-for-vue'
	export default {
		components: {
			HeaderCus,
			FooterCus,
			AdverRightCus,
			Editor,
			Toolbar,
		},
		data() {
			return {
				daqu: 0,
				mokuai: 0,
				kw: '',
				content: '',
				cur_user: {},
				temp_user_id: 0,
				
				list_prov: [],
				list_city: [],
				list_prov_type: ['primary', ],
				
				list_lingyu: [],
				list_lingyu_type: ['primary', ],
				
				list_year: [],
				list_year_type: ['primary', ],
				
				is_show_month: false,
				list_month: [],
				list_month_type: ['primary', ],
				
				list_daqu: [],
				list_daqu_type: ['primary', ],
				is_show_mokuai: false,
				list_mokuai: [],
				list_mokuai_type: ['primary', ],
				
				is_show_empty: false,
				daqu_id: 0, // 大区id
				mokuai_id: 0, // 模块id
				prov_text: '选择省份', // 用户选择的省份名
				city_text: '选择地市', // 用户选择的城市名
				prov_val: 0, // 用户选择的省份值
				city_val: 0, // 用户选择的城市值
				lingyu_val: 0, // 用户选择的领域
				year_val: 0, //用户选择的年份
				month_val: 0, // 用户选择的月份
				keyword: '', // 搜索关键词
				list_record: [], // 数据列表
				pi: 1, // 当前页码
				total: 0, //数据总数
				
				fullscreenLoading: false,
				
				search_type: '企业名称',
				list_search_type: [{val:0, text: '企业名称'}, {val:1, text: '正文内容'}],
				
				editor: null,
				html: '',
				toolbarConfig: {
					excludeKeys: ['insertImage', 'group-video', 'codeBlock', 'divider', 'todo', 'emotion', 'insertLink', 'group-more-style', 'blockquote', 'lineHeight'],
				},
				editorConfig: {
					placeholder: '此处可保存和备忘您企业的相关模块信息，形成您的企业画像，用于跟标杆企业对标。<br/><br/><br/>可复制左侧招股说明书中文字，也可将截图粘贴到此处<br/><br/><br/>快来试试吧',
					MENU_CONF:  {
						"uploadImage": {
							server: 'https://sudomanage.qqbd.vip/pubapi/pub_user_myxxx/editor/upImage',
							fieldName: 'file',
							// 继续写其他配置...
							
							//【注意】不需要修改的不用写，wangEditor 会去 merge 当前其他配置
						}
					},
				},
				mode: 'default', // or 'simple'

				is_show_myxxx_savebtn: -1,

			}
		},
		
		created() {
			this.daqu = sessionStorage.getItem('daqu') // 从sessionstorage中获取
			this.mokuai = sessionStorage.getItem('mokuai') // 从sessionstorage中获取
			this.kw = sessionStorage.getItem('kw') // 从sessionstorage中获取
			if (this.daqu > 0) {
				console.log('大区：' + this.daqu)
			} else {
				this.daqu = 0
			}
			if (this.mokuai > 0) {
				console.log('模块：' + this.mokuai)
			} else {
				this.mokuai = 0
			}
			if (this.kw) {
				console.log('kw：' + this.kw)
			} else {
				this.kw = '企业画像'
			}
			console.log('URL大区：' + this.daqu, 'URL大区模块：' + this.mokuai, 'URL KW：' + this.kw)
			if (this.daqu == 0 && this.mokuai == 0) {
				this.kw = '企业画像'
			}
			
			let trigger = this.$route.query.trigger
			// console.log(trigger)
			if (trigger == 'sch') {
				this.keyword = this.$route.query.kw
				let st = this.$route.query.st
				if (st == 0) {
					this.search_type = '企业搜索'
				} else {
					this.search_type = '全文检索'
				}
			}
			
		},
		
		mounted() {
			this.$router.beforeEach((to, from, next) => {
				// console.log(to, from)
				if (to.meta.title) {
					document.title = to.meta.title
				}
				next()
			})
			
			this.loadDictLingyu()
			this.loadDictYear()
			this.loadDictMonth()
			this.loadProv()
			// this.loadCity('37') // 点击省份后触发加载城市
			this.loadDaqu()
			// this.loadMokuai('1') // 点击大区触发加载模块
			
			if (this.daqu == 0 && this.mokuai == 0) {
				this.doSearch(1) // 加载列表数据
			} else if (this.daqu > 0 && this.mokuai == 0) {
				this.loadDaquAuto(this.daqu) // url传值中有大区，没模块
			} else if (this.daqu > 0 && this.mokuai > 0) {
				this.loadMokuaiAuto(this.daqu, this.mokuai) // url传值中有大区也有模块
			}

			this.cur_user = JSON.parse(localStorage.getItem('cur_user'));
			console.log('cur_user is:', this.cur_user)
			if (this.cur_user != null && this.cur_user != {}) {
				this.loadUserMyxxxContent()
			} else {
				// 用户未登录时记录查询次数
				let kw_record = localStorage.getItem('kw_record')
				if (kw_record) {
					if (kw_record.indexOf(this.kw) == -1) {
						kw_record += ',' + this.kw
						localStorage.setItem('kw_record', kw_record)
					}
				} else {
					kw_record = this.kw
					localStorage.setItem('kw_record', kw_record)
				}
				console.log('kw_record: ', kw_record)
				this.checkNoLoginRetrieveNum(kw_record)
			}
			this.checkLoginRetrieveNum()
		},

		beforeDestroy() {
			const editor = this.editor
			if (editor == null) return
			editor.destroy() // 组件销毁时，及时销毁编辑器
		},
		
		methods: {
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					// this.$router.push({path: url})
					let route_data = this.$router.resolve({path: url})
					// console.log(route_data)
					window.open(route_data.href, '_blank')
				}
			},
			
			// 标杆企业专用跳转详情页（标杆企业搜索结果跳转不同数据集，所以不用toUrl()单独写一个toDetail()方法）
			toDetail(com_id, daqu_id, mokuai_id) {
				console.log('com_id:' + com_id, 'daqu_id:' + daqu_id, 'mokuai_id:' + mokuai_id)
				if (daqu_id == 0 && mokuai_id == 0) {
					// 2025年10月份改成不跳到招股说明书注册稿，直接跳到企业详情页
					let url = '/detail_company?id=' + com_id // 直接跳到详情页
					// 这是以前跳到招股书注册稿的代码，2025年10月份改成不跳了
					// let url = '/detail_company?id=' + com_id + '&tozgs=zgszcg' // 跳转到招股说明书注册稿的参数
					let route_data = this.$router.resolve({path: url})
					window.open(route_data.href, '_blank')
				} else if (daqu_id == 0 && mokuai_id > 0) {
					// 注意这里daqu_id和mokuai_id做了换位处理，具体业务细节回头再考虑
					// 这里应该是后台处理了的，20240813不做过多深入
					let url = '/detail_company_prosp_sp?comid=' + com_id + '&moduleid=' + mokuai_id + '&daquid=0'
					let route_data = this.$router.resolve({path: url})
					window.open(route_data.href, '_blank')
				} else if (daqu_id > 0 && mokuai_id > 0) {
					let url = '/detail_company_prosp_sp?comid=' + com_id + '&moduleid=' + mokuai_id + '&daquid=' + daqu_id
					let route_data = this.$router.resolve({path: url})
					window.open(route_data.href, '_blank')
				}
			},
			
			// 跳转企业详情或企业问询答复列表
			toDetailSigle(com_id, label) {
				if (label == 'bg_detail') {
					let url = '/detail_company?id=' + com_id
					let route_data = this.$router.resolve({path: url})
					window.open(route_data.href, '_blank')
				} else if (label == 'wd_detail') {
					let url = '/detail_wenda_list?id=' + com_id
					let route_data = this.$router.resolve({path: url})
					window.open(route_data.href, '_blank')
				}
			},
			
			// 加载搜索数据，flag约定传值1或-1，flag为标记是否第1页，传1则第1页，传-1则不改变翻页值（使用已有第x页的值）
			doSearch(flag) {
				this.fullscreenLoading = true
				this.list_record = [] // 先设置成空有个视觉切换效果
				if (flag == 1) {
					this.pi = 1
				}
				let url = this.$common.apiUrl + 'pub_company_base/clientSearch'
				let client_data_json = {
					daqu_id: this.daqu_id,
					mokuai_id: this.mokuai_id,
					prov: this.prov_val,
					city: this.city_val,
					lingyu: this.lingyu_val,
					year: this.year_val,
					month: this.month_val,
					keyword: this.keyword,
					pi: this.pi,
					search_type: this.search_type
				}
				let client_data = this.$qs.stringify(client_data_json)
				this.$axios.post(url, client_data).then((res)=>{
					// console.log('搜索结果数据：', res.data)
					this.fullscreenLoading = false
					this.list_record = res.data.data.rows
					this.total = res.data.data.total
					if (this.list_record == 0) {
						this.is_show_empty = true
					} else {
						this.is_show_empty = false

						// 将搜索结果的大区标题和模块标题赋值到kw关键词，之前的的逻辑将daquName和mokuaiName都放到mokuaiName中了，20240628强企猫V1.1需求新增
						// console.log('搜索结果数据：', this.list_record)
						// let daquName = this.list_record[0].daquName
						let mokuaiName = this.list_record[0].mokuaiName
						if (mokuaiName != null) {
							this.kw = mokuaiName
							if (this.cur_user != null && this.cur_user != {}) {
								this.loadUserMyxxxContent()
							}
						}

					}
				})
				
				this.clearSessionStorageDaquMokuai() // 清空sessionstorage中的数据
			},
			
			// 清空搜索框时
			clearInput() {
				if (this.keyword == '') {
					this.doSearch(1)
				}
			},
			
			// 点击分页触发事件
			handlePage(page) {
				// console.log(page)
				this.pi = page
				this.doSearch(-1)
				document.documentElement.scrollTop = 0;
			},
			
			// 加载字典数据（行业领域）
			loadDictLingyu() {
				let url = this.$common.apiUrl + 'sys_dict_data/listByType/pub_dict_hangyelingyu'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_lingyu = res.data.data
					// 绑定样式数组
					this.list_lingyu.forEach((item, index) => {
						this.list_lingyu_type.push('info')
					})
				})
			},
			
			// 加载字典数据（年份）
			loadDictYear() {
				let url = this.$common.apiUrl + 'sys_dict_data/listByType/pub_dict_apply_year'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_year = res.data.data
					// 绑定样式数组
					this.list_year.forEach((item, index) => {
						this.list_year_type.push('info')
					})
				})
			},
			
			// 加载字典数据（月份）
			loadDictMonth() {
				let url = this.$common.apiUrl + 'sys_dict_data/listByType/pub_dict_apply_month'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_month = res.data.data
					// 绑定样式数组
					this.list_month.forEach((item, index) => {
						this.list_month_type.push('info')
					})
				})
			},
			
			// 加载省份
			loadProv() {
				let url = this.$common.apiUrl + 'pub_region/listProv'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_prov = res.data.data
				})
			},
			
			// 加载地市
			loadCity(provid) {
				let url = this.$common.apiUrl + 'pub_region/listCity/' + provid
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_city = res.data.data
				})
			},
			
			// 加载模块大区
			loadDaqu() {
				let url = this.$common.apiUrl + 'pub_company_module/listDaqu'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_daqu = res.data.data
					// 绑定样式数组
					this.list_daqu.forEach((item, index) => {
						this.list_daqu_type.push('info')
					})
				})
			},
			
			// 加载模块大区-自动赋值（有传参的情况）(只实现了业务，逻辑不够好，时间宽裕另行处理)
			loadDaquAuto(id) {
				let url = this.$common.apiUrl + 'pub_company_module/listDaqu'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_daqu = res.data.data
					// 绑定样式数组
					this.list_daqu.forEach((item, index) => {
						this.list_daqu_type.push('info')
					})
					
					// console.log(this.list_daqu)
					this.list_daqu.forEach((item, index) => {
						if (id == item.id) {
							this.$set(this.list_daqu_type, index+1, 'primary')
						} else {
							this.$set(this.list_daqu_type, 0, 'info')
							this.$set(this.list_daqu_type, index+1, 'info')
						}
					})
					this.daqu_id = id
					if (id == 0) {
						this.is_show_mokuai = false
						this.mokuai_id = 0
					} else {
						this.loadMokuaiAuto(id, 999999) // 加载大区下的模块
						this.is_show_mokuai = true
					}
					
					this.doSearch(1)
				})
			},
			
			// 加载二级模块
			loadMokuai(daquid) {
				let url = this.$common.apiUrl + 'pub_company_module/listMokuai/' + daquid
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_mokuai = res.data.data
					// 绑定样式数组
					this.list_mokuai.forEach((item, index) => {
						this.list_mokuai_type.push('info')
					})
				})
			},
			
			// 加载二级模块-自动赋值（有传参的情况）(只实现了业务，逻辑不够好，时间宽裕另行处理)
			loadMokuaiAuto(daquid, mokuaiid) {
				let url = this.$common.apiUrl + 'pub_company_module/listDaqu'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_daqu = res.data.data
					// 绑定样式数组
					this.list_daqu.forEach((item, index) => {
						this.list_daqu_type.push('info')
					})
					
					// console.log(this.list_daqu)
					this.list_daqu.forEach((item, index) => {
						if (daquid == item.id) {
							this.$set(this.list_daqu_type, index + 1, 'primary')
						} else {
							this.$set(this.list_daqu_type, 0, 'info')
							this.$set(this.list_daqu_type, index + 1, 'info')
						}
					})
					this.daqu_id = daquid
					if (daquid == 0) {
						this.is_show_mokuai = false
						this.mokuai_id = 0
					} else {
						// 加载大区下的模块
						// console.log('加载大区下的模块进行业务处理', this.is_show_mokuai)
						this.is_show_mokuai = true
						let url = this.$common.apiUrl + 'pub_company_module/listMokuai/' + daquid
						this.$axios.get(url).then((res)=>{
							// console.log(res)
							this.list_mokuai = res.data.data
							// 绑定样式数组
							this.list_mokuai.forEach((item, index) => {
								this.list_mokuai_type.push('info')
							})
							
							this.list_mokuai.forEach((item, idx)=>{
								if (mokuaiid == item.id) {
									this.$set(this.list_mokuai_type, idx + 1, 'primary')
								} else {
									this.$set(this.list_mokuai_type, 0, 'info')
									this.$set(this.list_mokuai_type, idx + 1, 'info')
								}
							})
							
							if (mokuaiid == 999999) {
								this.mokuai_id = 0
							} else {
								this.mokuai_id = mokuaiid
								this.doSearch(1) // 传递特殊标记，只有在id不等于999999时重新加载数据
							}
							
						})
					}
					
					// this.doSearch(1)
				})
				
				
			},
			
			// 选择省份
			selectProv(command) {
				// console.log(command)
				if (command == 0) {
					this.prov_val = 0
					this.prov_text = '选择省份'
					this.$set(this.list_prov_type, 0, 'primary')
				} else if (command > 0) {
					this.list_prov.forEach((item, index) => {
						if (item.id == command) {
							// console.log(item.name);
							this.prov_val = item.id
							this.prov_text = item.name
							this.loadCity(this.prov_val) // 加载下级城市
							this.$set(this.list_prov_type, 0, 'info')
							this.city_val = 0
							this.city_text = '选择城市'
						}
					})
				}
				
				this.doSearch(1)
			},
			
			// 选择城市
			selectCity(command) {
				if (command == 0) {
					this.city_val = 0
					this.city_text = '选择城市'
				} else if (command > 0) {
					this.list_city.forEach((item, index) => {
						if (item.id == command) {
							// console.log(item.name);
							this.city_val = item.id
							this.city_text = item.name
						}
					})
				}
				
				this.doSearch(1)
			},
			
			// 点击地区条件（这个略特殊，只有“不限”按钮触发）
			clickDiqu(index, id) {
				if (index == 0) {
					this.$set(this.list_prov_type, 0, 'primary')
					this.prov_val = 0
					this.prov_text = '选择省份'
					this.city_val = 0
					this.city_text = '选择城市'
				}
				
				this.doSearch(1)
			},
			
			// 点击领域条件
			clickLingyu(index, id) {
				console.log(index, id)
				this.list_lingyu_type.forEach((item, idx)=>{
					if (index == idx) {
						this.$set(this.list_lingyu_type, idx, 'primary')
					} else {
						this.$set(this.list_lingyu_type, idx, 'info')
					}
				})
				this.lingyu_val = id
				
				this.doSearch(1)
			},
			
			// 点击时间条件（年）
			clickYear(index, id) {
				// console.log(index, id)
				this.list_year_type.forEach((item, idx)=>{
					if (index == idx) {
						this.$set(this.list_year_type, idx, 'primary')
					} else {
						this.$set(this.list_year_type, idx, 'info')
					}
				})
				this.year_val = id
				
				if (index == 0) {
					this.is_show_month = false
					this.month_val = 0
				} else {
					this.is_show_month = true
					this.clickMonth(0, 999999)
				}
				
				this.doSearch(1)
			},
			
			// 点击月份条件（月）
			clickMonth(index, id) {
				// console.log(index, id)
				this.list_month_type.forEach((item, idx)=>{
					if (index == idx) {
						this.$set(this.list_month_type, idx, 'primary')
					} else {
						this.$set(this.list_month_type, idx, 'info')
					}
				})
				
				if (id == 999999) {
					this.month_val = 0
				} else {
					this.month_val = id
					this.doSearch(1) // 传递特殊标记，只有在id不等于999999时重新加载数据
				}
			},
			
			// 点击大区条件
			clickDaqu(index, id) {
				// console.log('点击大区条件',index, id)
				this.list_daqu_type.forEach((item, idx)=>{
					if (index == idx) {
						this.$set(this.list_daqu_type, idx, 'primary')
					} else {
						this.$set(this.list_daqu_type, idx, 'info')
					}
				})
				this.daqu_id = id
				
				if (index == 0) {
					this.is_show_mokuai = false
					this.mokuai_id = 0
				} else {
					this.loadMokuai(id) // 加载大区下的模块
					this.is_show_mokuai = true
					this.clickMokuai(0, 999999)
				}
				
				this.doSearch(1)

				console.log('我的xxx daqu_id', this.daqu_id, 'mokuai_id', this.mokuai_id)
			},
			
			// 点击二级模块条件
			clickMokuai(index, id) {
				// console.log(index, id)
				this.list_mokuai.forEach((item, idx)=>{
					if (index == idx) {
						this.$set(this.list_mokuai_type, idx, 'primary')
					} else {
						this.$set(this.list_mokuai_type, idx, 'info')
					}
				})
				
				if (id == 999999) {
					this.mokuai_id = 0
				} else {
					this.mokuai_id = id
					this.doSearch(1) // 传递特殊标记，只有在id不等于999999时重新加载数据
				}
				
				console.log('我的xxx daqu_id', this.daqu_id, 'mokuai_id', this.mokuai_id)
			},
			
			// 清除临时存储的sessionstorage的大区和模块
			clearSessionStorageDaquMokuai() {
				sessionStorage.setItem('daqu', 0)
				sessionStorage.setItem('mokuai', 0)
			},
			
			// 选择搜索类型
			selectSearchType(command) {
				// console.log(command)
				if (command == 0) {
					this.search_type = '企业名称';
				} else if (command == 1) {
					this.search_type = '正文内容';
				}
			},
			

			// 加载用户我的xxx数据
			loadUserMyxxxContent() {
				let period_url = this.$common.apiUrl + 'pub_user_period/detail';
				let period_data = this.$qs.stringify({'userId': this.cur_user.id})
				this.$axios.post(period_url, period_data).then((res)=>{
					console.log('user period data is: ', res.data)
					if (res.data.data.parentUserId > 0) {
						// parentUserId大于0，表示有父用户，该账号是个子账号，读写"我的xxx"都用父用户userid
						this.temp_user_id = res.data.data.parentUserId

						// 如果是个子账号，则查询该账号的写入权限
						let purview_url = this.$common.apiUrl + 'pub_user_myxxx_purview/getPurview';
						let purview_data = this.$qs.stringify({ 'userId': this.cur_user.id, 'rType': 1, 'daquId': this.daqu_id, 'mokuaiId': this.mokuai_id })
						this.$axios.post(purview_url, purview_data).then((purview_res) => {
							console.log('user purview_res data is: ', purview_res.data)
							if (purview_res.data.data.isPurviewWrite == 1) {
								this.is_show_myxxx_savebtn = 1
							} else {
								this.is_show_myxxx_savebtn = 0
							}
						})
					} else {
						// parentUserId不大于0，该账号是主账号，读写"我的xxx"用自己的userid
						this.temp_user_id = this.cur_user.id

						this.is_show_myxxx_savebtn = 1
					}

					let url = this.$common.apiUrl + 'pub_user_myxxx_content/getContent'
					let client_data_json = {'userId': this.temp_user_id, 'rType': 1, 'daquId': this.daqu_id, 'mokuaiId': this.mokuai_id}
					let client_data = this.$qs.stringify(client_data_json)
					this.$axios.post(url, client_data).then((res)=>{
						console.log('load cur_user data with userid/daquid/mokuaiid/rtype is: ', res.data, 'client_data is: ', client_data)
						if (res.data.data) {
							this.content = res.data.data.rContent
						} else {
							this.content = ''
						}
					})
				})
				
			},

			// 更新用户我的xxx数据
			updateUserMyxxxContent() {
				let url = this.$common.apiUrl + 'pub_user_myxxx_content/setContent'
				let client_data_json = {'userId': this.temp_user_id, 'rType': 1, 'daquId': this.daqu_id, 'mokuaiId': this.mokuai_id, 
					'rContent': this.content}
				let client_data = this.$qs.stringify(client_data_json)
				this.$axios.post(url, client_data).then((res)=>{
					console.log('update cur_user content data with id and kw, affcted rows is: ',res.data)
					if (res.data.data > 0) {
						// console.log('success...')
						this.$message({
							message: '保存信息成功',
							type: 'success'
						})
						// setTimeout(() => {
						// 	location.reload()
						// }, 700);
					}
				})
			},

			// 检查未登录时检索次数
			checkNoLoginRetrieveNum(kw_record) {
				// 2024年7月4日将限制未登录的需求改为限制登录后的免费浏览次数，此为止的限制暂时注释
				// this.$axios.get(this.$common.apiUrl + 'pub_web_config/detail/10105').then((res) => {
				// 	// console.log(res.data.data.configJson)
				// 	let retrieve_num = eval('(' + res.data.data.configJson + ')')['retrieveNum']
				// 	let cur_num = kw_record.split(',').length
				// 	console.log('当前检索:', cur_num, '限制检索:', retrieve_num)
				// 	if (cur_num >= retrieve_num) {
				// 		console.log('免登录次数限制', retrieve_num)
				// 		this.$message.error('用户未登录已达到最大检索次数，无法继续浏览，请登录后检索')
				// 		setTimeout(() => {
				// 			this.$router.push({path: '/login'})
				// 		}, 2500)
				// 	}
				// })
			},
			
			checkLoginRetrieveNum() { // 限制用户登录后的浏览次数
				// 2024年8月份版本，将列表页限制用户登陆浏览次数改成限制游客、注册未付费用户浏览详情页的数量，因此注释掉以下逻辑
				// let cur_num = parseInt(localStorage.getItem('retrieve_num'))
				// // console.log('retrieve_num1', cur_num)
				// if (cur_num) {
				// 	cur_num += 1
				// } else {
				// 	cur_num = 1
				// }
				// localStorage.setItem('retrieve_num', cur_num)
				// // console.log('retrieve_num2', num)
				// this.$axios.get(this.$common.apiUrl + 'pub_web_config/detail/10105').then((res) => {
				// 	// console.log(res.data.data.configJson)
				// 	let retrieve_num = eval('(' + res.data.data.configJson + ')')['retrieveNum']
				// 	console.log('当前浏览:', cur_num, '限制检索:', retrieve_num)
				// 	if (cur_num > retrieve_num) {
				// 		// console.log('免费用户检索限制', retrieve_num)
				// 		// 1、先判断是否是登录用户，非登录用户直接提示+跳转
				// 		if (this.cur_user != null && this.cur_user != {}) {
				// 			let url = this.$common.apiUrl + 'pub_user_period/detail'
				// 			let client_data = this.$qs.stringify({userId: this.cur_user.id})
				// 			// 2、如果是登录用户则判断是否是会员
				// 			this.$axios.post(url, client_data).then((res)=>{
				// 				// console.log('user_period:', res.data.data)
				// 				if (res.data.data) {
				// 					switch (res.data.data.dictUserType) {
				// 						case 1: // 3天体验用户
				// 							break
				// 						case 10: // 1人版 16800
				// 							break
				// 						case 11: // 2人版 21600
				// 							break
				// 						case 12: // 3人版 26400
				// 							break
				// 						case 19: // 多人版 38000
				// 							break
				// 						case 0: // 子用户
				// 							break
				// 						default:
				// 							this.$message.error('授权有误，请联系管理员处理')
				// 							setTimeout(() => {
				// 								this.$router.push({path: '/detail_article?id=129'})
				// 							}, 2500)
				// 							break
				// 					}
				// 				} else {
				// 					this.$message.error('用户未授权，请联系管理员授权会员')
				// 					setTimeout(() => {
				// 						this.$router.push({path: '/detail_article?id=129'})
				// 					}, 2500)
				// 				}
				// 			})
				// 		} else {
				// 			// 非登录用户
				// 			this.$message.error('用户免费浏览次数已达到最大限制，请登录账号后继续浏览')
				// 			setTimeout(() => {
				// 				this.$router.push({path: '/login'})
				// 			}, 2500)
				// 		}
						
						
				// 	}
				// })
			},

			onCreated(editor) {
				this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
			},
			customPaste(editor, event, callback) {
				// console.log('ClipboardEvent 粘贴事件对象', event)
				const html = event.clipboardData.getData('text/html') // 获取粘贴的 html
				// console.log('html:', html)
				const text = event.clipboardData.getData('text/plain') // 获取粘贴的纯文本
				// console.log('text', text)
				// const rtf = event.clipboardData.getData('text/rtf') // 获取 rtf 数据（如从 word wsp 复制粘贴）
				// console.log('rtf', rtf)

				if (html.indexOf('meta charset=') > -1 || html.indexOf('<html>') > -1 || html.indexOf('<body>') > -1 || html.indexOf('<span') > -1) {
					// 自定义插入内容
					editor.insertText(text)
					// 返回 false ，阻止默认粘贴行为
					event.preventDefault()
					callback(false) // 返回值（注意，vue 事件的返回值，不能用 return）
				} else {
					// 返回 true ，继续默认的粘贴行为
					callback(true)
				}

				// // 返回 false ，阻止默认粘贴行为
				// event.preventDefault()
				// callback(false) // 返回值（注意，vue 事件的返回值，不能用 return）

				// // 返回 true ，继续默认的粘贴行为
				// callback(true)
			},


			
		}
	}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>
.el-dropdown-link {
	cursor: pointer;
	color: #409EFF;
}
.el-icon-arrow-down {
	font-size: 12px;
}
.el-tag--small {
	margin: 0 10px;
}
.el-dropdown {
	margin: 0 10px;
}
.neirong_right_header {
	background-color: #E75122;
	border-top: 15px solid #E75122;
}
.myxxx_right_title {
	color: #E75122
}
</style>